import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { Sidebar } from '@/components/Sidebar'
import { useApp } from '@/contexts/AppContext'

export function Layout() {
  const { state, dispatch } = useApp()

  // Global keyboard shortcut: Ctrl+G to toggle shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check for Ctrl+G (or Cmd+G on Mac)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'g' || e.key === 'G' || e.code === 'KeyG')) {
        e.preventDefault()
        e.stopPropagation()
        
        // Toggle shortcuts - get current state and toggle it
        const currentValue = state.settings?.shortcutsEnabled ?? true
        dispatch({ type: 'TOGGLE_SHORTCUTS', payload: { enabled: !currentValue } })
      }
    }

    // Add listener at capture phase to ensure it fires before other handlers
    window.addEventListener('keydown', handleKeyDown, true)
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [state.settings?.shortcutsEnabled, dispatch])

  return (
    <div className="h-screen flex bg-background">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}